module.exports = __webpack_public_path__ + "static/img/1907_phase_function_Paper_Points.15aa105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1907_phase_function_Paper_Points.png
// module id = fnF5
// module chunks = 0